import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID, REQUEST } from '@angular/core';
import { catchError, map, Observable, of, shareReplay} from 'rxjs';

import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';
import { CookieService } from '../../../core/services/cookie/cookie.service';
import { Cookies } from '../../../shared/enums/app.enums';
import { APIResponse, Banner, commonApiResponse, EventStatus, followData, followRequest, jobDetailsExistingData, JobDetailsResponse, JobInsights, matchApiResponse, MatchingRequest, MatchingResponse, matchingResponse, MoreJobsData, MoreJobsPayload, MybdjobsResponse, ReportFormModel, shortlistBody, shortListResponse, Value } from '../models/details.model';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { readCookieFromHeader } from '../../../shared/utils/cookie.util';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavServices } from '../../../core/services/navServices/nav-services';
import { publicApi } from '../../../core/services/interceptors/token.interceptor';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobDetailService {
  private navService = inject(NavServices);
  // private detailsApiUrl = 'https://gateway.bdjobs.com/ActtivejobsTest/api/JobSubsystem/jobDetails'
  // private detailsApiUrl = 'https://gateway.bdjobs.com/jobapply/api/JobSubsystem/Job-Details'
  private detailsApiUrl = environment.detailsApiBaseUrl + 'jobDetails?'
  private remainingUrl = environment.detailsApiBaseUrl + 'JobDetailsExistingInfo'
  private applicationInsightsUrl
   ='https://apiv1.bdjobs.com/mybdjobsapi/v1/ApplicationInsightDetails.asp';
  // private matchingScoreUrl = "https://apiv1.bdjobs.com/mybdjobsapi/v1/ApplicationMatchingScore.asp";
  // private matchingScoreUrl = "https://apiv1.bdjobs.com/mybdjobsapi/v1/ApplicationMatchingScore_v1.asp"
  private matchingScoreUrl = environment.matchingScoreAspEndPoint;
  private reportApiUrl = environment.detailsApiBaseUrl + 'report';
  private moreJobsUrl = environment.companyOfferJobsApiUrl;
  private followApiUrl = environment.detailsApiDomainUrl + 'v1/JobSubsystem/follow';
  private shortlistUrl = environment.shortListJobApiUrl;
  private bannerUrl = environment.detailsApiBaseUrl + 'banner';
  private http = inject(HttpClient)
  private route = inject(ActivatedRoute)
  private authService = inject(AuthService)
  private cookieService = inject(CookieService)
  private platformId = inject(PLATFORM_ID);
  private request = inject(REQUEST);

  private IsProUser$?:Observable<boolean> | false = false;

  private isCorporate = toSignal(
    this.route.queryParams
    .pipe(
      map(params => params['src'] === 'recruiter.bdjobs.com' || this.authService.isCorporateUSer())
    ),
    { initialValue: false }
  )

  // private drafted = toSignal(
  //   this.route.queryParams
  //   .pipe(
  //     map(params => params['drafted'] === '1' ? 1 : 0)
  //   ),
  //   { initialValue: 0 }
  // )

  getJobDetails(request:
    { jobId: number; fcatId?:string, ln?: number, p?:string }): Observable<JobDetailsResponse> {
    return this.http.get<JobDetailsResponse>(this.detailsApiUrl, {
      params: {
        jobId: request.jobId,
        ln: request.ln ?? 1,
        IsCorporate:this.isCorporate(),
      },
      headers:{
        'BdjobsProData':this.cookieService.getCookie(Cookies.MyBDJOBSUSERID) ?? '',
      }

    });
  }


  getMatchingPercentage(encoded:string,jobId:number,formValue:string,deviceType:string): Observable<matchingResponse[]> {
    return this.http.get<APIResponse<matchingResponse[]>>(this.matchingScoreUrl, {
      params:{
        encoded:encoded,
        jobId:jobId,
        formValue:formValue,
        deviceType:deviceType
      }
     })
     .pipe(map(response => response.data));
  }

  getApplicationInsight(encoded:string, jobId:number, formValue:string, deviceType:string):Observable<JobInsights>{
    return this.http.get<APIResponse<JobInsights[]>>(this.applicationInsightsUrl,{
      params: {
        encoded:encoded,
        jobId: jobId,
        formValue:formValue,
        deviceType:deviceType,
      },
      context:publicApi()
    })
    .pipe(map(response => response.data[0] ?? null))
  }

  getIsProUser(cookieValue: string): Observable<boolean>{
    if(!this.IsProUser$){
      if (!cookieValue) {
        return this.IsProUser$ = of(false).pipe(shareReplay(1));
      }

      return this.IsProUser$ = this.navService.getSupportingInfo()
      // return this.IsProUser$ = this.http.get<MybdjobsResponse<Value>>(`${this.isProUserUrlFromMybdjobs}?UserGuid=${cookieValue}`)
        .pipe(
          map(response => {
            const eventType = response.event.eventType;
            if(eventType === EventStatus.Error){
              return false;
            }
            return response.event.eventData[0]?.value?.currentUser.bdjobsPro?.isProUser ?? false
          }),
          shareReplay(1)
        );
    }
    return this.IsProUser$;
  }

  getRemainingData(deviceType:string, formValue:string,JobId:number, CompanyId:string,CompanyName:string):Observable<APIResponse<jobDetailsExistingData>>{
    return this.http.get<APIResponse<jobDetailsExistingData>>(this.remainingUrl,{
      params: {
        deviceType:deviceType,
        formValue: formValue,
        JobId:JobId,
        CompanyId:CompanyId,
        CompanyName:CompanyName
      }
    })
  }

  postReportForm(body:ReportFormModel):Observable<any>{
    return this.http.post<any>(this.reportApiUrl, body);
  }

  getMoreJobsFromCompanies(payload: MoreJobsPayload): Observable<MoreJobsData[]> {
    const params = new HttpParams()
      .set('deviceType', payload.deviceType.toString())
      .set('formValue',payload.formValue.toString())
      .set('Company_ID', payload.Company_ID)
      .set('Company_Name', payload.Company_Name.toString())
      .set('Alias_Status', payload.Alias_Status.toString());

    return this.http.get<APIResponse<MoreJobsData[]>>(this.moreJobsUrl, { params }).pipe(
      map(response => response.data)
    );
  }

  followJob(payload: followRequest): Observable<followData> {
    const params = new HttpParams()
      .set('deviceType', payload.deviceType)
      .set('formValue', payload.formValue)
      .set('id', payload.id)
      .set('actType', payload.actType)
      .set('name', payload.name)
      .set('categoryId',payload.categoryId)
      .set('jobId',payload.jobId)

    return this.http
      .post<APIResponse<followData[]>>(this.followApiUrl, {}, { params })
      .pipe(
        map((response: APIResponse<followData[]>) => response.data[0])
      );
  }

  shortListedJob(payload:shortlistBody):Observable<shortListResponse>{
    return this.http.post<shortListResponse>(this.shortlistUrl,payload)
  }

  getBannerList():Observable<Banner[]>{
    return this.http.get<commonApiResponse<Banner[]>>(this.bannerUrl).pipe(
      map(response =>response.Data)
    )
  }

  getMatchingInfo(payload:MatchingRequest):Observable<MatchingResponse[]>{
    if (isPlatformServer(this.platformId)) {
      const cookie = this.request?.headers?.get('cookie') ?? '';
      payload.GuidId = readCookieFromHeader(cookie, Cookies.MYBDJOBSGID) ?? '';
    }
    if (isPlatformBrowser(this.platformId)) {
      payload.GuidId = this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? '';
    }
    const headers = new HttpHeaders({
      GuidId:decodeURIComponent(payload.GuidId)
    })
    return this.http.get<matchApiResponse<MatchingResponse[]>>(`${environment.matchingEndPoint}?JobId=${payload.JobId}`,{headers})
      .pipe(
        map(response => response.data)
      )
  }

  public checkImageExists(url: string): Observable<string> {
    const placeholderImg = 'https://jobs.bdjobs.com/images/bdjobslogo_sharedlinks.png';

    return this.http.head(url, { observe: 'response',context : publicApi() }).pipe(
      map((res) => (res.status === 200 ? url : placeholderImg)),
      catchError(() => of(placeholderImg)) // 👈 404 or any error → placeholder
    );
  }
}
